export const getCurrencyCode = (symbol: string): string => {
  if (symbol === 'EUR') {
    return '€';
  } else if (symbol === 'GBP') {
    return '£';
  }
  return symbol;
};
